export const SwapsScannerPermissions = {
  default: 'User.RiskMonitoring.SwapsScanner',
  internalTab: 'User.RiskMonitoring.SwapsScanner.InternalSwap',
  externalTab: 'User.RiskMonitoring.SwapsScanner.ExternalSwap',
  brokersTab: 'User.RiskMonitoring.SwapsScanner.BrokerSwaps',
} as const;
